import React from 'react';
import ReactTooltip from 'react-tooltip';
import Questionmark from '../../assets/img/question-mark.svg';

export default function TooltipCheckoutSidebarRevised({ place = 'right', classAdded }) {
  return (
    <>
      <img
        data-event="click"
        className={`k-tooltip-icon ${classAdded}`}
        data-tip
        data-for="checkoutSidebarRevised"
        role="tooltip"
        src={Questionmark}
        alt="Tooltip Due Today"
      />
      <ReactTooltip
        globalEventOff="click"
        clickable
        className="k-tooltip-theme"
        data-html
        id="checkoutSidebarRevised"
        place={place}
        effect="solid"
      >
        <div className="k-checkout-tooltip">
          The revised cart is the total cash price of the items that will be leased.
        </div>
      </ReactTooltip>
    </>
  );
}
